import clsx from 'clsx';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PlanDetailsCard } from '@/modules/payment';
import { IPayment } from '@/modules/payment/types';

import ArrowUp from '~/images/shared/ArrowUp.svg';

const PlansCollapes: React.FC<
  IPayment.IBundleDetailsCollapseSchema & {
    isLast: boolean;
  }
> = ({ collapseList, collapseTitle, isLast }) => {
  const { t } = useTranslation('payment');
  const [open, setOpen] = useState(true);

  return (
    <div className={clsx('flex w-full flex-col', !open && 'mb-1')}>
      <div
        className='flex cursor-pointer items-center justify-between gap-2 rounded-xl bg-surface-30 p-16'
        onClick={() => setOpen((value) => !value)}
      >
        <span className='text-base font-semi-bold text-text-default'>
          {t(collapseTitle)}
        </span>
        <span
          className={clsx(
            'transition-all duration-500 ease-in-out',
            !open && 'rotate-180'
          )}
        >
          <ArrowUp />
        </span>
      </div>
      <div
        className={clsx(
          'flex flex-col overflow-hidden transition-all duration-1000 ease-in-out',
          open ? 'h-auto' : 'h-0'
        )}
      >
        {collapseList.map((item, idx) => (
          <PlanDetailsCard
            key={idx}
            {...item}
            isLast={isLast}
            isLastIdx={idx === collapseList.length - 1}
          />
        ))}
      </div>
    </div>
  );
};

export { PlansCollapes };
